export const createContextValueWarningProxy = contextName =>
// eslint-disable-next-line @typescript-eslint/no-unsafe-argument
new Proxy({}, {
  get(_, property) {
    if (typeof window === "undefined") return; // Prevent server side render will throw error
    throw new Error(`You must implement the ${property} by wrapping the component inside <${contextName}.provider value={{${property}}} />`);
  }
});